import Bottom from './Bottom';
export default Bottom;
//# sourceMappingURL=index.js.map